import { render, staticRenderFns } from "./Consultas.vue?vue&type=template&id=5d17a94c"
import script from "./Consultas.vue?vue&type=script&lang=js"
export * from "./Consultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports